import { Html } from "@react-three/drei";
import { forwardRef, useLayoutEffect, useState } from "react";
import * as THREE from "three";
import { useRef } from "react";
import { GiClick } from "react-icons/gi";
import { invalidate, useFrame } from "@react-three/fiber";

const Backdrop = forwardRef((props, ref) => {
  const { showVideo, ...rest } = props;
  const material = useRef();
  const [showIcon, setShowIcon] = useState(false);
  const [video] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: "/cybertruck_video.mp4",
      crossOrigin: "Anonymous",
      loop: true,
      muted: true,
      playsInline: true,
    })
  );

  const playVideo = () => {
    showVideo
      ? video
          .play()
          .then(() => setShowIcon(false))
          .catch((e) => setShowIcon(true))
      : null;
  };

  useLayoutEffect(() => {
    if (!video) return;

    setShowIcon(false);

    if (showVideo) {
      const videoTexture = new THREE.VideoTexture(video);
      playVideo();
      material.current.map = videoTexture;
    } else {
      material.current.map = null;
    }
  }, [showVideo, ref, video]);

  useFrame(() => {
    if (showVideo === "play") {
      invalidate();
    }
  });

  return (
    <>
      <mesh {...rest} ref={ref} position-y={4} onClick={playVideo}>
        <planeGeometry args={[40, 8]} />
        <meshBasicMaterial
          ref={material}
          toneMapped={false}
          color={[1.2, 1.2, 1.2]}
          side={THREE.DoubleSide}
          encoding={THREE.sRGBEncoding}
          onUpdate={(self) => (self.needsUpdate = true)}
        />
        <Html transform rotation-y={Math.PI} zIndexRange={[0, 0]}>
          {showIcon ? <GiClick className="click" /> : null}
        </Html>
      </mesh>
    </>
  );
});

export default Backdrop;
